export const PROJECT_CATEGORIES = [
  { code: "1",   label: "1 De Ofertat" },
  { code: "1.2", label: "1.2 Întrebat Detalii Fără Răspuns" },
  { code: "2",   label: "2 Ofertat" },
  { code: "3",   label: "3 Întrebat Părere Ofertă" },
  { code: "4",   label: "4 Refuzate" },
  { code: "5",   label: "5 Anmelduite SUVA" },
  { code: "6",   label: "6 Sanierungskonzept" },
  { code: "6.1", label: "6.1 Finalizat de demontat" },
  { code: "7",   label: "7 Demontat de Facturat" },
  { code: "8",   label: "8 Facturat" },
  { code: "9",   label: "9 Abmelduit SUVA" },
  { code: "10",  label: "10 Întrebat De Părere" },
  { code: "11",  label: "11 Băgat Pe Site" },
];

export const PLANNING_CATEGORIES = ["5", "6"]; // doar aceste proiecte pot fi bagate în plan

export const TEAM_COLORS = [
  { code: "blue",   label: "Echipa Albastră",   hex: "#3B82F6" },
  { code: "green",  label: "Echipa Verde",      hex: "#10B981" },
  { code: "yellow", label: "Echipa Galbenă",    hex: "#FACC15" },
  { code: "orange", label: "Echipa Portocalie", hex: "#F59E0B" },
  { code: "red",    label: "Echipa Roșie",      hex: "#EF4444" },
  { code: "purple", label: "Echipa Violet",     hex: "#A855F7" },
  { code: "cyan",   label: "Echipa Cyan",       hex: "#06B6D4" },
  { code: "pink",   label: "Echipa Roz",        hex: "#EC4899" },
  { code: "gray",   label: "Echipa Gri",        hex: "#6B7280" },
];

export const getCategoryLabel = (code) => PROJECT_CATEGORIES.find((c) => c.code === code)?.label || code;
